import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, CircularProgress, Alert, Grid, List, ListItem, ListItemText, Divider } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

function UserDetailsPage() {
    const { id } = useParams();
    const { token } = useAuth();
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                const { data } = await axios.get(`/api/admin/users/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setDetails(data);
            } catch (err) {
                setError('Failed to fetch user details.');
            } finally {
                setLoading(false);
            }
        };
        fetchDetails();
    }, [id, token]);

    if (loading) return <AdminLayout><CircularProgress /></AdminLayout>;
    if (error) return <AdminLayout><Alert severity="error">{error}</Alert></AdminLayout>;
    if (!details) return <AdminLayout><Typography>User not found.</Typography></AdminLayout>;

    return (
        <AdminLayout>
            <Typography variant="h4" gutterBottom>User Details: {details.user.username}</Typography>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper sx={{ p: 2 }}>
                        <Typography variant="h6">Profile Information</Typography>
                        <Typography><strong>Email:</strong> {details.user.email}</Typography>
                        <Typography><strong>Admin:</strong> {details.user.isAdmin ? 'Yes' : 'No'}</Typography>
                        <Typography><strong>Blocked:</strong> {details.user.isBlocked ? 'Yes' : 'No'}</Typography>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper sx={{ p: 2 }}>
                        <Typography variant="h6">Items Posted ({details.posts.length})</Typography>
                        <List>
                            {details.posts.map(post => (
                                <ListItem key={post._id}>
                                    <ListItemText primary={post.itemName} secondary={`Type: ${post.type}, Status: ${post.status}`} />
                                </ListItem>
                            ))}
                        </List>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper sx={{ p: 2 }}>
                        <Typography variant="h6">Reports Made ({details.reports.length})</Typography>
                        <List>
                            {details.reports.map(report => (
                                <ListItem key={report._id}>
                                    <ListItemText primary={`Reported Item ID: ${report.itemId}`} secondary={`Reason: ${report.reason}`} />
                                </ListItem>
                            ))}
                        </List>
                    </Paper>
                </Grid>
            </Grid>
        </AdminLayout>
    );
}

export default UserDetailsPage;
